import React from 'react'
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native'
import { useNavigation, useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { iconApp } from '@assets'
import { Text } from '@components'
import { SocialNetworkSection } from '../../screens/profile/components/SocialNetworkSection'
import { useScreen } from '../../hooks/useScreen'
import { useLanguage } from '@context'
import { GlobalNavigationProp } from '../navigationTypes'

interface WebFooterProps {

}

export const WebFooter: React.FC<WebFooterProps> = ({ }) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const { isMobile, isTablet } = useScreen()
  const navigation = useNavigation<GlobalNavigationProp>()
  const styles = getStyle(theme, isMobile || isTablet)

  const navigateToFooterPage = (screen: 'LegalNotice' | 'ContactUs' | 'PrivacyPolicy' | 'JoinUs') => {
    navigation.navigate('Menu', { screen })
  }

  return (
    <View style={styles.footer}>
      <View style={styles.headerLeft}>
        <Image source={iconApp} style={styles.headerLogo} />
        <Text type="headline" color={theme.colors.white}>
          KEEPTOUCH
        </Text>
      </View>
      <View style={styles.headerRight}>
        {!isMobile && [{
          title: t('webFooter.legalNotice'),
          onPress: () => navigateToFooterPage('LegalNotice'),
        }, {
          title: t('webFooter.contactUs'),
          onPress: () => navigateToFooterPage('ContactUs'),
        }, {
          title: t('webFooter.privacyPolicy'),
          onPress: () => navigateToFooterPage('PrivacyPolicy'),
        }, {
          title: t('webFooter.joinUs'),
          onPress: () => navigateToFooterPage('JoinUs'),
        }
      ].map((item, index) => (
          <TouchableOpacity
            key={index}
            onPress={item.onPress}
            activeOpacity={0.7}
          >
            <Text type={isTablet ? "microText" : "bodySmall"} color={theme.colors.white}>{item.title}</Text>
          </TouchableOpacity>
        ))}
        <View style={styles.socialNetworks}>
          <SocialNetworkSection color={theme.colors.white} isSmall facebook='facebook.com' instagram='instagram.com' twitter='twitter.com' linkedin='linkedin.com' />
        </View>
      </View>
    </View>
  )
}

const getStyle = (theme: Theme, isTablet: boolean) => StyleSheet.create({
  footer: {
    height: 50,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: isTablet ? theme.spacing.sm : theme.spacing.lg,
    paddingVertical: theme.spacing.md,
    backgroundColor: theme.colors.primary,
  },
  headerLogo: {
    width: 30,
    height: 30,
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.md,
  },
  headerRight: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: isTablet ? theme.spacing.md : theme.spacing.xxxl,
  },
  socialNetworks: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.md,
  }
})
